<div class="authenticating-container container" fxFlexFill fxLayoutAlign="center center">
  <div fxLayout="column" fxLayoutAlign="start center" role="alert" aria-live="polite">
    <img src="assets/images/cube-preloader.svg" alt="Loading animation" />
    <h2 class="mat-h2 color-primary">{{ 'auth.signing_in' | translate }}</h2>
  </div>
</div>
